<template>
  <div v-if="value" :class="['consult-notice', { none: down }]">
    <template v-if="$slots.default">
      <p class="tips">
        <slot />
      </p>
    </template>
    <template v-else-if="TipsType">
      <v-touch
        tag="p"
        class="tips not-fiexd"
        @tap="touchEvent"
        v-html="descText"
      >
      </v-touch>
    </template>
    <template v-else>
      <v-touch
        tag="p"
        :class="['tips', down ? '' : 'slide-down']"
        @tap="updateOrDownLoadApp"
      >
        点击<a href="javascript:"> 下载最新版的APP </a> 完成咨询
      </v-touch>
    </template>
    <v-touch v-if="isShowClose" class="close" @tap="switchDisplay"
      ><i class="yxl-font yxl-font-close "></i
    ></v-touch>
  </div>
</template>

<script>
import { updateOrDownLoadApp } from '../../libs/utils'
import bridgeMixin from '../../mixins/bridge'

export default {
  name: 'consultNotice',
  mixins: [bridgeMixin],

  props: {
    context: {
      type: String
    },
    TipsType: {
      type: String
    },
    scrollHidden: {
      type: Boolean,
      default: false
    },
    yuyueCompleteNum: {
      type: Number
    },
    value: {
      type: Boolean,
      default: true
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    role: {
      type: String
    }
  },
  data() {
    return {
      scrollTop: 0,
      down: false,
      isShow: true
    }
  },

  computed: {
    descText() {
      let text = ''
      if (this.TipsType === 'unPaid') {
        text = `您有预约订单尚未支付，<a href="javascript:"> 点击查看 </a>`
      } else if (this.TipsType === 'letter') {
        text = `《给初次体验咨询的你一封信》，<a href="javascript:"> 点击查看 </a>`
      }
      return text
    }
  },

  mounted() {
    window.addEventListener('scroll', () => {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      this.scrollTop = scrollTop
    })
  },
  methods: {
    updateOrDownLoadApp,
    touchEvent() {
      if (this.TipsType === 'unPaid') {
        const url = `${this.staticSite}#/consult-list-${this.role}`
        this.$emit('linkEvents', { name: '待支付提示', url: url })
      } else if (this.TipsType === 'letter') {
        const url = `${this.staticSite}#/consult-letter?source=consult-index`
        this.$emit('linkEvents', {
          name: '一封信提示',
          url: url,
          callBack: () => {
            localStorage.setItem('ZX_INDEX_LETTER', 1)
          }
        })
      }
    },
    switchDisplay() {
      window.yxl.stat.send({
        name: '咨询-交互行为',
        properties: {
          行为: '点击',
          对象: '咨询主页-关闭横幅'
        }
      })
      this.$emit('input', false)
      if (this.TipsType === 'letter') {
        localStorage.setItem('ZX_INDEX_LETTER', 1)
      }
    }
  },
  watch: {
    scrollTop(newval, oldval) {
      if (!this.scrollHidden) return
      if (newval > 100) {
        this.down = true
      }
      if (newval - oldval < 0 && newval < 68) {
        this.down = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/sass/config';
@import '../../assets/sass/function';
@import '../../assets/sass/mixin';

.consult-notice {
  height: 34px;
  // height: pxToRem(68);
  background: #fff5e2;
  position: relative;
  .close {
    position: absolute;
    right: pxToRem(30);
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    .yxl-font {
      @include font-dpr(12px);
    }
  }
  &.none {
    height: 0;
    display: none;
  }
  &.slide-up {
    transform: translate3d(0, -400%, 0);
  }
  .tips {
    position: fixed;
    background: #fff5e2;
    width: pxToRem(750);
    margin-left: pxToRem(-750/2);
    left: 50%;
    z-index: 7;
    font-size: 12px;
    height: 34px;
    display: flex;
    line-height: 1.25;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s;
    &.slide-up {
      transform: translate3d(0, -400%, 0);
    }

    &.not-fiexd {
      position: static;
      margin: 0;
    }
    a {
      text-decoration: none;
      margin: 0 3px;
      color: #459cf3;
      // text-decoration: underline;
      border-bottom: 1px solid #459cf3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// consultNotice.vue?263c9ecf